import { xlCol, xlColq } from "../../../common/constants"

//export const rechargeHistoryPageTabs = [{name:"Branch Recharge",JobID:1},{name:"Party Recharge",JobID:2}]
export const rechargeHistoryPageTabs = [{ name: "Branch Recharge", JobID: 1 }]
export const RechargeHistoryPageTabIds = (index) => {
  return {
    id: `rechargeHistoryPage-tab-${index}`,
    'aria-controls': `rechargeHistoryPage-tabpanel-${index}`,
  }
}

export const excelHeader = [
  { col: 2, value: 'From Recharge Date' },
  { col: 2, value: 'To Recharge Date' },
  { col: 3, value: 'Branch City' },
  { col: 3, value: 'Branch Name' },
  { col: 3, value: 'Recharge Mode' },
]

//excel pdf header
export const excelHeaderColumn = [
  {
    headerName: 'From Recharge Date',
    exportHead: 'From Recharge Date',
    field: 'fromDate',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'To Recharge Date',
    exportHead: 'To Recharge Date',
    field: 'toDate',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Branch City',
    exportHead: 'Branch City',
    field: 'branchCity',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'branchName',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Recharge Mode',
    exportHead: 'Recharge Mode',
    field: 'rechargeMode',
    xlCol: xlCol,
    align: 'left',
  },
]
// Column definitions
export const columnDefs = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    minWidth: "80px",
    col: 1,
    field: 'SN',
    xlCol: xlCol,
    headerSx: { minWidth: '50px' },
    align: 'left',
    weight: 40
  },
  {
    headerName: 'Branch City',
    exportHead: 'Branch City',
    minWidth: "80px",
    col: 1,
    field: 'CityName',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 120,
    isSortIcon: true,
  },
  {
    headerName: 'Branch ID',
    exportHead: 'Branch ID',
    minWidth: "80px",
    col: 1,
    field: 'BranchID',
    xlCol: xlColq,
    headerSx: { minWidth: '60px' },
    align: 'right',
    weight: 100,
    isSortIcon: true,
  },
  {
    headerName: 'Branch Name',
    exportHead: 'Branch Name',
    minWidth: "80px",
    col: 1,
    field: 'BranchName',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 150,
    isSortIcon: true,
  },
  {
    headerName: 'Payment Mode',
    exportHead: 'Payment Mode',
    minWidth: "80px",
    col: 1,
    field: 'PaymentMode',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 100,
    isSortIcon: true,
  },
  {
    headerName: 'Bank Name',
    exportHead: 'Bank Name',
    minWidth: "80px",
    col: 1,
    field: 'BankName',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 130,
    isSortIcon: true,
  },
  {
    headerName: 'Chq/DD/Txn Reference No.',
    exportHead: 'Chq/DD/Txn Reference No.',
    minWidth: "100px",
    col: 2,
    field: 'chqNo',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 180,
    isSortIcon: true,
  },
  {
    headerName: 'Transaction Date - Time',
    exportHead: 'Transaction Date - Time',
    minWidth: "100px",
    col: 2,
    field: 'transactionDateTime',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 120,
    isSortIcon: true,
  },
  {
    headerName: 'Recharge Amount',
    exportHead: 'Recharge Amount',
    minWidth: "80px",
    col: 1,
    field: 'RechargeAmount',
    xlCol: xlColq,
    headerSx: { minWidth: '60px' },
    align: 'right',
    weight: 80,
    isSortIcon: true,
  },
  {
    headerName: 'Request Raised By',
    exportHead: 'Request Raised By',
    minWidth: "100px",
    col: 2,
    field: 'RaisedBy',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 180,
    isSortIcon: true,
  },
  {
    headerName: 'Status',
    exportHead: 'Status',
    minWidth: "80px",
    col: 1,
    field: 'status',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 100,
    isSortIcon: true,
  },
  {
    headerName: 'Accepted / Rejected By',
    exportHead: 'Accepted / Rejected By',
    minWidth: "100px",
    col: 2,
    field: 'AcceptedOrRejectedUser',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 180,
    isSortIcon: true,
  },
  {
    headerName: 'Accepted / Rejected Date - Time',
    exportHead: 'Accepted / Rejected Date - Time',
    minWidth: "100px",
    col: 2,
    field: 'AcceptedOrRejectedDateTime',
    xlCol: xlCol, // or date if you apply formatter
    headerSx: { minWidth: '60px' },
    align: 'left',
    weight: 180,
    isSortIcon: true,
  },
];


//for party recharge 

//excel pdf header
export const excelHeaderColumnTwo = [
  {
    headerName: 'From Recharge Date',
    exportHead: 'From Recharge Date',
    field: 'frmDate',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'To Recharge Date',
    exportHead: 'To Recharge Date',
    field: 'ToDate',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Party City',
    exportHead: 'Party City',
    field: 'partyCity',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Party Name',
    exportHead: 'Party Name',
    field: 'partyName',
    xlCol: xlCol,
    align: 'left',
  },
  {
    headerName: 'Recharge Mode',
    exportHead: 'Recharge Mode',
    field: 'rechargeMode',
    xlCol: xlCol,
    align: 'left',
  },
]

// Column definitions
export const columnDefsTwo = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    field: 'sn',
    xlCol: { dataType: 'Number', dataFormatter: null },
    headerSx: { minWidth: '50px' },
    align: 'left',
  },
  {
    headerName: 'Party City',
    exportHead: 'Party City',
    field: 'partyCity',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Party ID',
    exportHead: 'Party ID',
    field: 'partyId',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Party Name',
    exportHead: 'Party Name',
    field: 'partyName',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Payment Mode',
    exportHead: 'Payment Mode',
    field: 'paymentMode',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Bank Name',
    exportHead: 'Bank Name',
    field: 'bankName',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Chq/DD/Txn Reference No.',
    exportHead: 'Chq/DD/Txn Reference No.',
    field: 'referenceNo',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Transaction Date - Time',
    exportHead: 'Transaction Date - Time',
    field: 'transactionDate',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Recharge Amount',
    exportHead: 'Recharge Amount',
    field: 'rechargeAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    headerSx: { minWidth: '60px' },
    align: 'right',
  },
  {
    headerName: 'Request Raised By',
    exportHead: 'Request Raised By',
    field: 'requestRaisedBy',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Status',
    exportHead: 'Status',
    field: 'status',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Accepted / Rejected By',
    exportHead: 'Accepted / Rejected By',
    field: 'acceptedBy',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
  {
    headerName: 'Accepted / Rejected Date - Time',
    exportHead: 'Accepted / Rejected Date - Time',
    field: 'acceptedDate',
    xlCol: xlCol,
    headerSx: { minWidth: '60px' },
    align: 'left',
  },
];

export const tableDataTwo = [
  {
    sn: 1,
    partyCity: 'Ahmedabad',
    partyId: '1234',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'UPI - QR',
    bankName: 'HDFC Bank - 200003124',
    referenceNo: 'TXN000012345643211',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Auto Accepted',
    acceptedBy: 'Auto Transaction',
    acceptedDate: '18-10-2024, 12:25',
  },
  {
    sn: 2,
    partyCity: 'Ahmedabad',
    partyId: '2345',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'Cash',
    bankName: 'State Bank Of India',
    referenceNo: 'NA',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Accepted',
    acceptedBy: 'Kirtan Pandya',
    acceptedDate: '18-10-2024, 12:25',
  },
  {
    sn: 3,
    partyCity: 'Ahmedabad',
    partyId: '3456',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'Cheque',
    bankName: 'State Bank Of India',
    referenceNo: '654321',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Rejected',
    acceptedBy: 'Kirtan Pandya',
    acceptedDate: '18-10-2024, 12:25',
  },
  {
    sn: 4,
    partyCity: 'Ahmedabad',
    partyId: '4567',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'DD',
    bankName: 'State Bank Of India',
    referenceNo: '345634',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Pending',
    acceptedBy: 'Kirtan Pandya',
    acceptedDate: '18-10-2024, 12:25',
  },
  {
    sn: 5,
    partyCity: 'Ahmedabad',
    partyId: '5678',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'Net Banking',
    bankName: 'State Bank Of India',
    referenceNo: 'RTGS0003456543211',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Pending',
    acceptedBy: 'Kirtan Pandya',
    acceptedDate: '18-10-2024, 12:25',
  },
  {
    sn: 6,
    partyCity: 'Ahmedabad',
    partyId: '6789',
    partyName: 'Maven Ops Ahmedabad',
    paymentMode: 'Cash',
    bankName: 'State Bank Of India',
    referenceNo: 'NA',
    transactionDate: '18-10-2024, 12:25',
    rechargeAmount: 10000,
    requestRaisedBy: 'Kirtan Pandya',
    status: 'Pending',
    acceptedBy: 'Kirtan Pandya',
    acceptedDate: '18-10-2024, 12:25',
  },
]


export const ColumnStyles1 = {
  0: {
    fontSize: 18,
    valign: 'middle',
    font: 'Roboto',
    fontStyle: 'normal',
    cellPadding: 12,
    minCellHeight: 36,
    halign: 'left',
    textColor: [0, 0, 0],
  },
  1: {
    fontSize: 18,
    valign: 'middle',
    font: 'Roboto',
    fontStyle: 'normal',
    cellPadding: 12,
    minCellHeight: 36,
    halign: 'left',
    textColor: [0, 0, 0],
  },
  2: {
    fontSize: 18,
    valign: 'middle',
    font: 'Roboto',
    fontStyle: 'normal',
    cellPadding: 12,
    minCellHeight: 36,
    halign: 'left',
    textColor: [0, 0, 0],
  },
  3: {
    fontSize: 18,
    valign: 'middle',
    font: 'Roboto',
    fontStyle: 'normal',
    cellPadding: 12,
    minCellHeight: 36,
    halign: 'left',
    textColor: [0, 0, 0],
  },
  4: {
    fontSize: 18,
    valign: 'middle',
    font: 'Roboto',
    fontStyle: 'normal',
    cellPadding: 12,
    minCellHeight: 36,
    halign: 'left',
    textColor: [0, 0, 0],
  },
}

export const ColumnStyles2 = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}

// export const getStatusColor = (status) => {
//   switch (status) {
//     case 'Auto Accepted':
//       return 'blue'
//     case 'Accepted':
//       return 'green'
//     case 'Rejected':
//       return 'red'
//     case 'Pending':
//       return 'orange'
//     default:
//       return 'black'
//   }
// }